import { render, staticRenderFns } from "./iframebSales.vue?vue&type=template&id=d86c530a&scoped=true"
import script from "./iframebSales.vue?vue&type=script&lang=js"
export * from "./iframebSales.vue?vue&type=script&lang=js"
import style0 from "./iframebSales.vue?vue&type=style&index=0&id=d86c530a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86c530a",
  null
  
)

export default component.exports